import { batchPrintStepsType } from "../../../../customTypes/batchPrintModal";
import { Container, LinearProgress, Typography } from "@mui/material";

interface IBatchPrintingExceptionsMessage {
    batchPrintSteps: batchPrintStepsType
}

const BatchPrintingExceptionsMessage: React.FC<IBatchPrintingExceptionsMessage> = ({ batchPrintSteps }) => {
    return (
        <>
            {
                batchPrintSteps.confirmingPrintJobs && (
                    <Container disableGutters sx={{ display: "flex", width: "100%", alignItems: "center", justifyContent: "space-evenly" }}>
                        <LinearProgress
                            variant="indeterminate"
                            sx={{ width: "95%", marginRight: "8px" }}
                        />
                    </Container>
                )
            }
            {
                batchPrintSteps.pdfGenError && (
                    <Typography sx={{ maxWidth: "600px" }} variant="body1">
                        An error has occurred while preparing a PDF document containing the selected transaction(s).
                        Please 'try again' or 'cancel'.
                    </Typography>
                )
            }
            {
                batchPrintSteps.docExpired && (
                    <Typography sx={{ maxWidth: "600px" }} variant="body1">
                        PDF Link has expired. If a new link is required select 'Try Again'. Otherwise select 'Cancel' to
                        return to the Batch Print selection screen.
                    </Typography>
                )
            }
        </>
    )

}

export default BatchPrintingExceptionsMessage